import { type Router } from 'vue-router';

export default defineNuxtPlugin((nuxtApp) => {
    const router = nuxtApp.$router as Router;
    nuxtApp.vueApp.config.errorHandler = (error, context) => {
        router.replace('/error?hasBackHistory=false');
    }
})